var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "ul",
    {
      staticClass: "widget-list widget-links cw-action-widget",
    },
    [
      _vm.templatesView
        ? _c(
            "li",
            {
              staticClass: "cw-action-widget-add",
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    href: "#",
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.addTemplate.apply(null, arguments)
                    },
                  },
                },
                [_c("translate", [_vm._v("Vorlage hinzufügen")])],
                1
              ),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }